export const APP_INFO = {
  APP_VERSION: '2.14.0',
  APP_BUILD: '3013123',
  APP_DATE: '04.11.2026',
  MIN_DB_VERSION: '3',
  APP_DEPLOY_VERSION: '1',
  APP_MIN_PERFORMANCE_SCORE: 35,
  MIN_WEBVIEW_VERSION: 80,
};
